var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
import omit from "lodash.omit";
import { bonfireGet } from "../../theme";
import { classnames } from "../../utils";
import { body } from "../../typography";
import { CloseIcon } from "../Icons/CloseIcon";
var TagStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n\n  display: flex;\n\n  .bn-tag-label {\n    ", ";\n    padding: 3px 5px;\n    color: ", ";\n  }\n\n  .bn-tag-close {\n    flex-shrink: 0; /* Do not squish this element */\n    align-self: center;\n    cursor: pointer;\n    padding-right: 3px;\n  }\n"], ["\n  background: ", ";\n  border-radius: 4px;\n\n  display: flex;\n\n  .bn-tag-label {\n    ", ";\n    padding: 3px 5px;\n    color: ", ";\n  }\n\n  .bn-tag-close {\n    flex-shrink: 0; /* Do not squish this element */\n    align-self: center;\n    cursor: pointer;\n    padding-right: 3px;\n  }\n"])), function (props) { return bonfireGet("colors", props.$backgroundColor); }, body, bonfireGet("colors", "textLight"));
var Tag = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, requestRemove = _a.onRequestRemove, children = _a.children, props = __rest(_a, ["className", "onRequestRemove", "children"]);
    var onRequestRemove = React.useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (requestRemove) {
            requestRemove();
        }
    }, [requestRemove]);
    return (React.createElement(TagStyle, __assign({}, omit(props, "backgroundColor"), { "$backgroundColor": (_b = props.backgroundColor) !== null && _b !== void 0 ? _b : "surface", ref: ref, className: classnames(className, "bn-tag") }),
        React.createElement("span", { className: "bn-tag-label" }, children),
        requestRemove && (React.createElement(CloseIcon, { size: "small", iconColor: "textLight", className: "bn-tag-close", onClick: onRequestRemove }))));
});
/** @component */
export default Tag;
var templateObject_1;
//# sourceMappingURL=Tag.js.map